import {
  beRecipientGetGroupById,
  beRecipientGetListOfGroupDetails
} from 'Api/beRecipientApi'
import { STORE_KEY_ID_LIST } from 'Constants/'
import getIntl from 'Helpers/intl'
import { storeGet } from 'Helpers/localStorage'
import debounce from 'lodash/debounce'
import { MESSAGE_BOX_VARIANT_DANGER } from 'mailup-web-components'
import { useEffect, useRef } from 'react'
import { atom, useRecoilCallback, useRecoilState } from 'recoil'

export const DO_NOTHING = '0'
export const COPY = '1'
export const MOVE = '2'
export const EMPTYGROUP = '3'
export const GROUP_MAX_ITEMS = 100

export const ANY_ITEM = {
  label: getIntl().formatMessage({
    id: 'Load.AutomationWorkflow.EndConditionMoveFromAnyGroup'
  }),
  value: 0
}

export async function getGroups(searchString) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const { Items: groups, TotalItems: count } =
    await beRecipientGetListOfGroupDetails(idList, {
      pageSize: GROUP_MAX_ITEMS,
      pageNumber: 1,
      searchBy: searchString
    })

  return { groups, count }
}

export async function getGroup(idGroup) {
  const g = await beRecipientGetGroupById(idGroup)
  return g
    ? { label: `${g.Id} - ${g.Name}`, value: g.Id }
    : { label: '', value: -1 }
}

export const modalEndConditionState = atom({
  key: 'modalEndConditionState',
  default: {
    count: 0,
    items: undefined,
    loading: true,
    loaded: false,
    error: false,
    errMessage: '',
    severity: MESSAGE_BOX_VARIANT_DANGER,
    check: DO_NOTHING,
    copyValue: { label: '', value: -1 },
    emptyValue: { label: '', value: -1 },
    moveFromValue: { label: '', value: -1 },
    moveToValue: { label: '', value: -1 },
    show: false,
    close: false,
    selectedGroups: [],
    selectedGroupsTo: [],
    loadGroups: false,
    loadGroup: false,
    selectCollapsed: false,
    IsDiry: false
  }
})

const useModalEndCondition = () => {
  const [
    { items, loaded, loading, error, errMessage, severity, anyItems },
    setState
  ] = useRecoilState(modalEndConditionState)

  const fetchGroupsCallback = useRecoilCallback(
    ({ snapshot }) =>
      async (searchValue) => {
        setState((prev) => ({
          ...prev,
          loadGroups: true
        }))
        try {
          const { groups, count } = await getGroups(searchValue)
          const items = groups.map((t) => ({
            label: `${t.Id} - ${t.Name}`,
            value: t.Id
          }))
          setState((prev) => ({
            ...prev,
            items,
            count
          }))
        } catch (error) {
          setState((prev) => ({
            ...prev,
            error: true,
            errMessage: getIntl().formatMessage({
              id: 'Load.Alerts.ErrorGeneric'
            }),
            severity: MESSAGE_BOX_VARIANT_DANGER
          }))
        }

        setState((prev) => ({
          ...prev,
          loading: false,
          loaded: true,
          loadGroups: false
        }))
      },
    []
  )

  const fetchGroupCallback = useRecoilCallback(
    ({ snapshot }) =>
      async (idGroup) => {
        setState((prev) => ({
          ...prev,
          loadGroup: true
        }))
        let group = {}
        try {
          group = await getGroup(idGroup)
        } catch (error) {
          setState((prev) => ({
            ...prev,
            error: true,
            errMessage: getIntl().formatMessage({
              id: 'Load.Alerts.ErrorGeneric'
            }),
            severity: MESSAGE_BOX_VARIANT_DANGER
          }))
        }
        setState((prev) => ({
          ...prev,
          loadGroup: false
        }))
        return group
      },
    []
  )
  useEffect(() => {
    fetchGroupsCallback('')
  }, [])

  const { current: fetchGroups } = useRef(
    debounce(async (value) => {
      await fetchGroupsCallback(value)
    }, 250)
  )

  return {
    items,
    loaded,
    loading,
    error,
    errMessage,
    severity,
    anyItems,
    fetchGroups,
    fetchGroup: fetchGroupCallback
  }
}

export default useModalEndCondition
